// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2227) return "static/chunks/2227-d5b59e758ed4684a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"200":"435b5273a5465d43","937":"d5affb3464d9f990","4079":"fa0559d6b9565288","4748":"a8c51bca3f969ce8","4819":"0ff2a574893b1ed5","5315":"5bba14654f46e528","7274":"778c5f210b65e6e0","7487":"251f40021411e8a4","8645":"6a623d634cdf8f31","9795":"9a63d6741e20e3e9"}[chunkId] + ".js";
};